import type { ICampaignsRequestParams } from "./types"

export const campaignKeys = {
  all: ["campaign"] as const,
  details: () => [...campaignKeys.all, "detail"] as const,
  detail: (campaign_guid: string | undefined) =>
    [...campaignKeys.details(), campaign_guid] as const,
  campaigns: (params: ICampaignsRequestParams | undefined) =>
    [...campaignKeys.details(), "campaigns", params] as const,
}
